(function () {
  function mountBannerSixContent() {
    var slide = document.querySelector('#shopify-section-home #anHero.hero .hero-slide:nth-child(6)');
    if (!slide || slide.querySelector('.an-hero-copy-layer--artform')) return;

    var scrim = document.createElement('div');
    scrim.className = 'an-hero-copy-scrim an-hero-copy-scrim--artform';
    scrim.setAttribute('aria-hidden', 'true');

    var layer = document.createElement('div');
    layer.className = 'an-hero-copy-layer an-hero-copy-layer--artform';
    layer.innerHTML = [
      '<div class="an-hero-copy an-hero-copy--artform">',
      '<h2 aria-label="Because Fragrance Is An Art Form">',
      '<span class="an-hero-art-line an-hero-art-line--first"><span class="an-hero-art-word">Because</span> <span class="an-hero-art-word an-hero-art-word--fragrance">Fragrance</span></span>',
      '<span class="an-hero-art-line"><span>Is An</span> <span class="an-hero-art-accent">Art Form.</span></span>',
      '</h2>',
      '<p>Discover exceptional scents chosen not by trends, but by artistry and emotion.</p>',
      '<a class="an-hero-cta an-hero-cta--artform" href="/collections">Discover Our Selection</a>',
      '</div>'
    ].join('');

    slide.appendChild(scrim);
    slide.appendChild(layer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountBannerSixContent);
  } else {
    mountBannerSixContent();
  }

  window.addEventListener('pageshow', mountBannerSixContent);
  document.addEventListener('shopify:section:load', mountBannerSixContent);
})();
